import { styled } from '@mui/material';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Typography, { TypographyProps } from '@mui/material/Typography';
import Box, { BoxProps } from '@mui/material/Box';

export const QuoteBody = styled(Box)<BoxProps>(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    marginBottom: 12,
    maxHeight: 48,
    padding: 8,
    gap: 8,
    borderRadius: 12,
    color: theme.palette.quote.main,
    backgroundColor: theme.palette.quote.dark,

    'svg': {
        alignSelf: 'flex-start',
        flexShrink: 0,
        color: theme.palette.quote.light,
    },

    [theme.breakpoints.down('md')]: {
        marginBottom: 8,
        paddingTop: 4,
        paddingBottom: 4,
    }
}))

export const QuoteText = styled(Typography)<TypographyProps>
    (() => ({
        display: '-webkit-box',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
    }))

export const QuoteCancleButton = styled(IconButton)<IconButtonProps>
    (() => ({
        color: 'inherit',
        padding: 0,
        marginLeft: 'auto'
    }))
